import apiClient from "./apiClient";

// Attendance corrections (internal employees; approved through the DTR chain).
// Correction { id, date, sessionId|null, original: { checkInTime, checkOutTime }|null,
//   requested: { checkInTime|null, checkOutTime|null }, reason,
//   status: "PENDING"|"APPROVED"|"REJECTED"|"CANCELLED", levels: { current, total },
//   approvals, reviewedAt, reviewRemarks, createdAt, canCancel?, waitingFor? }
export const correctionService = {
  // { date, sessionId?, checkInTime?, checkOutTime?, reason } (times ISO +08:00)
  // With sessionId: fix that session (send only what changes). Without: add a session.
  create: (data) => apiClient.post("/attendance/corrections", data),
  getMine: (status) =>
    apiClient.get("/attendance/corrections/my", {
      params: status ? { status } : {},
    }),
  cancel: (id) => apiClient.post(`/attendance/corrections/${id}/cancel`),
};
